import React from "react";
import Button from "../../components/Button/Button";
import ApplicationFooter from "../../components/Footer/ApplicationFooter";
import { PageTitle } from "../../PageTitle";
import { BodyText } from "../../styles/Typography";
import { useDownloadFile } from "../../hooks/useDownloadFile";
import {
  Container,
  SectionHeader,
  Subheader,
  Header,
  SubheaderLine,
  ButtonContent,
} from "./PrivacyPolicyAndConsent.styles";

const PrivacyPolicy: React.FC = () => {
  const downloadFile = useDownloadFile();
  const PDF_URL = "/documents/privacy-policy.pdf";
  const PDF_FILENAME = "Политика обработки персональных данных ООО ИРТ.pdf";

  return (
    <>
      <PageTitle title="Политика в отношении обработки персональных данных — Интеллект-Развитие-Технологии" />
      <Container id="privacy">
        <Header>
          <SectionHeader>
            политика в отношении обработки персональных данных
          </SectionHeader>
          <SubheaderLine>
            <BodyText>Редакция от 08.10.2026 </BodyText>
            <Button
              outlined
              small
              onClick={() => downloadFile(PDF_URL, PDF_FILENAME)}
            >
              <ButtonContent>
                <span>Скачать в PDF</span>
                <i className="pi pi-download" />
              </ButtonContent>
            </Button>
          </SubheaderLine>
        </Header>
        <Subheader>1. Общие положения</Subheader>
        <BodyText>
          1.1. Настоящая Политика определяет принципы, цели, условия и порядок
          обработки персональных данных физических лиц оператором: Общество с
          ограниченной ответственностью «ИНТЕЛЛЕКТ-РАЗВИТИЕ-ТЕХНОЛОГИИ» (ООО
          «ИРТ»), ИНН 7203368755, ОГРН 1167232050050, адрес: Тюменская область,
          г. Тюмень, Московский тракт, д. 141, корп. 3, кв. 95 (далее —
          Оператор).
        </BodyText>
        <BodyText>
          1.2. Политика разработана в соответствии с Федеральным законом от
          27.07.2006 № 152-ФЗ «О персональных данных» и применяется к обработке
          персональных данных в рамках деятельности Оператора по разработке,
          предоставлению прав использования, продаже лицензий и сопровождению
          любых программных продуктов ООО «ИРТ», а также взаимодействию с
          потенциальными и действующими клиентами, их представителями и лицами,
          обращающимися за технической поддержкой.
        </BodyText>
        <BodyText>
          1.3. Персональные данные — информация, относящаяся к прямо или
          косвенно определённому или определяемому физическому лицу. Обработка
          включает действия, предусмотренные статьёй 3 Закона № 152-ФЗ. Действие
          Политики не означает, что Оператор собирает все перечисленные ниже
          категории сведений у каждого лица.
        </BodyText>

        <Subheader>2. Категории субъектов, цели и состав данных</Subheader>
        <BodyText>
          2.1. Представители юридических лиц и индивидуальные предприниматели,
          ведущие переговоры или заключающие и исполняющие лицензионные
          договоры: ФИО, место работы и должность (при наличии), номер телефона
          и электронная почта, сведения о полномочиях и переписке. Цели:
          подготовка предложений, коммуникация, оформление, исполнение и
          документирование договорных отношений, включая лицензирование любых
          программных продуктов ООО «ИРТ».
        </BodyText>
        <BodyText>
          2.2. Пользователи любых программных продуктов, право использования
          которых предоставляет ООО «ИРТ», обращающиеся за установкой,
          активацией, обновлениями или технической поддержкой: ФИО (если
          сообщено), рабочие контакты, организация, содержание обращения,
          сведения о версии ПО, ключе или идентификаторе лицензии, техническая
          информация, которую пользователь самостоятельно передаёт в обращении.
          Цели: предоставление и сопровождение лицензий на программные продукты,
          активация, помощь в установке и эксплуатации, обновление программ,
          обработка обращений, устранение ошибок и защита законных интересов
          сторон.
        </BodyText>
        <BodyText>
          2.3. Посетители сайта и лица, направляющие заявки через формы сайта
          (если такие формы используются): имя, контактные сведения и содержание
          обращения. Цели: приём и обработка заявок, обратная связь и
          обеспечение работы сайта. На дату настоящей редакции Оператор не
          использует cookies и сервисы аналитики для сбора персональных данных
          посетителей сайта. В случае внедрения cookies, инструментов аналитики
          или иных технологий автоматического сбора информации Оператор до
          начала их использования уточнит состав обрабатываемых данных, цели и
          правовые основания обработки, при необходимости обновит настоящую
          Политику и запросит предусмотренное законом согласие.
        </BodyText>

        <Subheader>3. Правовые основания и принципы</Subheader>
        <BodyText>
          3.1. Правовые основания обработки определяются для каждой конкретной
          цели согласно статье 6 Закона № 152-ФЗ: согласие субъекта, исполнение
          предусмотренных законом обязанностей, договорные и иные
          предусмотренные законом основания. Согласие запрашивается там, где оно
          необходимо; настоящая Политика сама по себе согласием не является.
        </BodyText>
        <BodyText>
          3.2. Обработка осуществляется законно, справедливо, для конкретных
          заранее определённых целей, с соблюдением требований к минимизации
          состава данных, точности и ограничению сроков хранения.
        </BodyText>

        <Subheader>4. Порядок и условия обработки</Subheader>
        <BodyText>
          4.1. Оператор может осуществлять сбор, запись, систематизацию,
          накопление, хранение, уточнение (обновление, изменение), извлечение,
          использование, обезличивание, блокирование, удаление и уничтожение
          персональных данных с использованием средств автоматизации либо без
          них.
        </BodyText>
        <BodyText>
          4.2. Оператор ограничивает доступ к данным кругом уполномоченных лиц,
          принимает необходимые правовые, организационные и технические меры
          защиты, обеспечивает конфиденциальность данных, кроме случаев,
          предусмотренных законодательством.
        </BodyText>
        <BodyText>
          4.3. Вопросы трансграничной передачи, обработки специальных категорий
          персональных данных и биометрических персональных данных регулируются
          требованиями законодательства Российской Федерации. Оператор
          осуществляет такие операции только при наличии соответствующих
          правовых оснований и соблюдении установленных законом условий.
        </BodyText>

        <Subheader>5. Сроки хранения и прекращение обработки</Subheader>
        <BodyText>
          5.1. Персональные данные обрабатываются и хранятся до достижения
          соответствующих целей обработки или до отзыва согласия, если обработка
          основана на согласии. Иной срок обработки или хранения применяется,
          когда он установлен федеральным законом, договором либо имеется иное
          законное основание. Документы, подлежащие обязательному хранению по
          требованиям бухгалтерского, налогового и иного законодательства,
          хранятся в установленные законодательством сроки.
        </BodyText>
        <BodyText>
          5.2. При достижении цели обработки или отзыве согласия Оператор
          прекращает обработку персональных данных и уничтожает их в срок, не
          превышающий 30 дней, если отсутствуют предусмотренные законом или
          договором основания для продолжения обработки либо иной допустимый
          срок. Требование субъекта о прекращении обработки рассматривается в
          порядке и сроки, предусмотренные Федеральным законом № 152-ФЗ. При
          наличии иного законного основания обработка может быть продолжена
          независимо от отзыва согласия.
        </BodyText>

        <Subheader>6. Права физических лиц</Subheader>
        <BodyText>
          6.1. Субъект персональных данных вправе получать сведения об обработке
          своих данных, требовать их уточнения, блокирования или уничтожения при
          наличии законных оснований, отзывать ранее данное согласие, а также
          обжаловать действия Оператора в Роскомнадзор или суд.
        </BodyText>
        <BodyText>
          6.2. Обращения по вопросам обработки персональных данных, включая
          запросы о доступе, уточнении, прекращении обработки и отзыв согласия,
          могут направляться на адрес электронной почты info@i-d-tech.com либо
          по почтовому адресу Оператора, указанному в разделе 1 настоящей
          Политики.
        </BodyText>
        <BodyText>
          6.3. Оператор рассматривает запросы и исполняет обязанности в сроки,
          предусмотренные Законом № 152-ФЗ, после необходимых проверок личности
          и полномочий заявителя.
        </BodyText>

        <Subheader>7. Публикация и изменения</Subheader>
        <BodyText>
          7.1. Оператор обеспечивает неограниченный доступ к настоящей Политике
          и сведениям о реализуемых требованиях защиты персональных данных. При
          сборе данных через сайт Политика публикуется на страницах сайта,
          используемых для такого сбора.
        </BodyText>
        <BodyText>
          7.2. Изменения Политики оформляются новой редакцией; актуальная
          редакция доступна в месте её публикации.
        </BodyText>

        <Subheader>8. Контакты оператора</Subheader>
        <BodyText>
          Общество с ограниченной ответственностью
          «ИНТЕЛЛЕКТ-РАЗВИТИЕ-ТЕХНОЛОГИИ» (ООО «ИРТ»), ИНН 7203368755, ОГРН
          1167232050050, адрес: Тюменская область, г. Тюмень, Московский тракт,
          д. 141, корп. 3, кв. 95. Электронная почта для обращений по вопросам
          персональных данных: info@i-d-tech.com.
        </BodyText>
      </Container>
      <ApplicationFooter />
    </>
  );
};

export default PrivacyPolicy;
